export default __webpack_public_path__ + "static/media/call-people-group.de1c2f07.svg";